export enum LanguageShortname {
  DE = "de",
  EN = "en",
  ES = "es",
}
